// GAVION inbound calls: back to the « Appel entrant » link after a sign-in that lost it. main.tsx stashes the link
// (sessionStorage, this tab only) when the page loads on #/appel-entrant; the email/password login already returns to
// it (ra-core nextPathname/nextSearch), but a Microsoft sign-in comes back to the home page. The first signed-in screen
// then opens the stashed link if it is less than 10 minutes old (domain/dialer/inboundCall.ts takeInboundRoute).
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  INBOUND_ROUTE,
  takeInboundRoute,
} from "../../domain/dialer/inboundCall";

export function useInboundReturn(
  storage: Pick<Storage, "getItem" | "removeItem"> | null = typeof window ===
  "undefined"
    ? null
    : window.sessionStorage,
  nowMs: () => number = Date.now,
): void {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // on the page itself, the page spends the stash
    if (!storage || pathname === INBOUND_ROUTE) return;
    const route = takeInboundRoute(storage, nowMs());
    if (route) navigate(route, { replace: true });
    // once, at the first signed-in screen
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
